export class TimezoneSelector {
    offset: number;
    name: string;
}
